import React, { useState, useEffect } from "react";
import "./header.css";
import { Dropdown } from "react-bootstrap";
import logoutIcon from "../../assets/logout.svg";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/storeRequests";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import useAuth from "../../hooks/useAuth";
import useIdleTimout from "../../hooks/useIdleTimout";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import "@fortawesome/fontawesome-free/css/all.min.css";
 
interface HeaderProps {
  title: string;
}
 
const Header: React.FunctionComponent<HeaderProps> = ({ title }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentUser = useAuth();
  const worker = useIdleTimout();
  const { userBasic } = useAppSelector(StoreSelectors.USER_STATE);
 
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
 
  useEffect(() => {
    // Update collapse state from local storage
    const storedValue = localStorage.getItem("sidebarCollapsed");
    setIsCollapsed(storedValue === "true");
  }, []);
 
  const handleClick = () => {
    // Update state and local storage when the button is clicked
    const newValue = !isCollapsed;
    setIsCollapsed(newValue);
    localStorage.setItem("sidebarCollapsed", newValue.toString());
    console.log("Menu icon clicked");
 
    // Dispatch an event to notify other components
    window.dispatchEvent(new Event("storage"));
  };
 
  const logout = async () => {
    try {
      if (currentUser === 1) {
        // await getDetails(APIList.ADMIN_LOGOUT);
        localStorage.clear();
        sessionStorage.clear();
        navigate("/admin/login");
 
        dispatch(showToast("Logged out successfully !!!"));
        setTimeout(() => dispatch(hideToast()), 2000);
 
        if (worker !== null) {
          worker.postMessage("terminate");
        }
      }
    } catch (error) {
      console.log("Error while logging out...");
    }
  };
 
  return (
    <header className="admin-header-container ">
      <div className="d-flex align-items-center justify-content-between ">
        <div className="menutoggle  ">
          <a className="anchor ">
            <i className="fa fa-bars " onClick={handleClick}></i>
          </a>
        </div>
        <div className="header-profile-section border-start  ">
          <div className="no-text-decoration d-flex align-items-center justify-content-center ">
            <Dropdown align={"end"}>
              <Dropdown.Toggle
                id="dropdown-profile"
                className="text-capitalize font-14 weight-400 p-0 bg-none profile-dropdown-btn border-0 d-flex  text-primary-color"
              >
                <small className="user-profile-text">Admin</small>{" "}
                <i className="dropdown fa fa-sort-desc  ps-2" aria-hidden="true"></i>
              </Dropdown.Toggle>
 
              <Dropdown.Menu className="border-0 profile-dropdown-menu py-0">
                <Dropdown.Item 
                className="profile-dropdown-item profile-dropdown-cover"
                style={{cursor:"default", pointerEvents: "none"}}
                onClick={(e:any) => e.preventDefault()}
                >
                  <p className="mb-2 text-capitalize font-color-dropDown font-13 weight-400 w-100">
                    Welcome, <strong>Admin</strong>
                  </p>
                  <p className="mb-0 weight-400 font-color-dropDown header-email">
                    {userBasic?.email}
                  </p>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={logout}
                  className="profile-dropdown-item  d-flex "
                >
                  <img
                    className="me-2 logout-icon"
                    width="15"
                    height="15"
                    src={logoutIcon}
                    alt="logout"
                    style={{ color: 'red' }}
                  />
                  <p className="mb-0 text-capitalize font-color-dropDown font-13 weight-500">
                    Log Out
                  </p>
                  
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </header>
  );
};
 
export default Header;

